import { Inject, Injectable, forwardRef} from '@angular/core';
import { Http, Response } from '@angular/http';

import  { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/toPromise';

import { HttpClient } from './http-client.service';

import { MemberUserPermission, Permission, PermissionType } from '../../entities/security';

import { Settings } from '../../settings';
import { DateConverter } from '../../utility/date-converter';
import { ODataBuilder } from '../../utility/odata/odata-builder';
import { ODataComparer } from '../../utility/odata/odata-comparer';

@Injectable()
export class MemberUserPermissionService {

  private static readonly permissionBaseUrl:string = `${Settings.apiUrl}/v1/MemberUserPermissions`;

  constructor(@Inject(forwardRef(() => HttpClient)) private http:HttpClient) { }

  getPermissionsForMember(memberUserId:string, fiscalYearId:number, orgNodeId:string):Promise<MemberUserPermission[]>{
    let oDataBuilder:ODataBuilder = new ODataBuilder(MemberUserPermissionService.permissionBaseUrl);

    oDataBuilder.filter("MemberUserId", ODataComparer.Equals, memberUserId)
      .filter("OrgNodeId", ODataComparer.Equals, orgNodeId)
      .filter("FiscalYearId", ODataComparer.Equals, fiscalYearId);

    let memberUserPermissionUrl:string = oDataBuilder.toString();

    return this.http.get(memberUserPermissionUrl)
      .map(response => {
              let formattedReponse:any[] = response.json().value;

              return formattedReponse;
            }).toPromise();
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/http/member-user-permission.service.ts